import { useState } from "react";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import { TOAST_MESSAGES } from "../constants";
import toast from "react-hot-toast";
import { getESSs, addESS, deleteESSs} from "../../../Services/essServices";
import { getAllUsers } from "../../../Services/UserService";
import { RESET_PAGINATION } from "../../../Constants/Strings";

export const useESS = () => {
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        search: null,
        user: null,
    });
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pagination, setPagination] = useState(RESET_PAGINATION);
    const [ess, setESS] = useState([]);


    const onPageChange = (newPage) => setPage(newPage);

    const onPageSizeChange = (newSize) => {
        setRowsPerPage(newSize);
        setPage(1);
    };

    const fetchAllESS = async (params) => {
        setLoading(true);
        try {
            const response = await getESSs({
                ...filters,
                limit: pagination.limit,
                offset: pagination.offset,
                ...params,
            });
            if (response.status === 200) {
                const results = response.data?.results || [];

                setPagination({
                    limit: pagination.limit,
                    offset: response.data.offset ?? 0,
                    count: response.data.count ?? 0,
                });
                return results; 
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.ESS_FETCH_FAILED
            );
        } finally {
            setLoading(false);
        }
        return []; 
    };

    const loadMoreESS = async () => {
        if (pagination.offset >= pagination.count) return;

        const data = await fetchAllESS({ offset: pagination.offset });
        setESS(prev => [...prev, ...data]);
    };

    const uploadEmpDocument = async (formData) => {
        setLoading(true);

        try {
            const response = await addESS(formData);

            if (response.status === 201 || response.status === 200) {
                toast.success(TOAST_MESSAGES.ESS_UPLOADED);
                return true;
            } else {
                toast.error(TOAST_MESSAGES.ESS_UPLOAD_FAILED);
                return false;
            }

        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.ESS_UPLOAD_FAILED
            );
            return false;
        } finally {
            setLoading(false);
        }
    };

    const getUsers = async ({ search = "", mode = "all" } = {}) => {
        setLoading(true);
        let data = null;
        try {
            const response = await getAllUsers({
                mode,
                search,
                limit: rowsPerPage,
                offset: (page - 1) * rowsPerPage,
            });

            if (response.status === 200) {
                setTotalPages(
                    Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
                );
                data = response.data?.results;
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.USER_FETCH_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.USER_FETCH_FAILED
            )
        } finally {
            setLoading(false);
            return data;
        }
    };


    const deleteESS = async (id) => {
        setLoading(true);
        let success = false;
        try {
            const response = await deleteESSs(id);
            if (response.status === 204) {
                toast.success(TOAST_MESSAGES.SUCCESS_DELETE_ESS);
                success = true;
            } else {
                const msg =
                    extractErrorMessage(response) || TOAST_MESSAGES.FAILED_DELETE_ESS;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.ERROR_DELETE_ESS
            );
        } finally {
            setLoading(false);
            return success;
        }
    };

    return {
        loading,
        filters,
        setFilters,
        page,
        totalPages,
        rowsPerPage,
        onPageChange,
        onPageSizeChange,
        fetchAllESS,
        uploadEmpDocument,
        getUsers,
        deleteESS,
        loadMoreESS,
        pagination,
        ess,
        setESS,
    };
};
